import { Component, ConsumerProps } from 'react';

import IntlContext, { IntlContextValue } from './IntlContext';

export type IntlConsumerProps = ConsumerProps<IntlContextValue>;

export class IntlConsumer extends Component<IntlConsumerProps> {

    render() {
        return (
            <IntlContext.Consumer children={this.props.children} />
        );
    }

}
